import styled from 'styled-components'

const FilterBarStyle = styled.div`
	--filterBarMarginTop: var(--sp7x);
	--filterPadding: var(--sp2x) var(--sp5x);
	--filterMarginRight: var(--sp3x);
	--filterMarginTop: var(--sp2x);
	--rangePickerMaxWidth: var(--sp63x);
	--filterSameHeight: var(--sp7x);
	--filterItemBorderRadius: var(--sp2x);
	--secondLineMarginTop: var(--sp5x);
	--hashtagMarginLeft: var(--sp3x);

	margin-top: var(--filterBarMarginTop);

	.filter-first-line {
		display: flex;
		justify-content: space-between;

		.category-filters {
			display: flex;
			flex-wrap: wrap;
			margin-top: calc(var(--filterMarginTop) * -1);

			.ant-select {
				.ant-select-selector {
					min-height: var(--filterSameHeight);
					width: var(--rangePickerMaxWidth);

					.ant-select-selection-item {
						display: flex;
						align-items: center;
					}
				}
			}

			.filter-item {
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: var(--filterMarginTop);
				padding: var(--filterPadding);
				background-color: var(--primaryColor3);
				border-radius: var(--filterItemBorderRadius);
				margin-right: var(--filterMarginRight);
				transition: var(--trTime);
				max-height: var(--filterSameHeight);

				cursor: pointer;

				&.active {
					background-color: var(--primaryColor2);
					pointer-events: none;
				}

				@media (hover: hover) {
					&:hover {
						background-color: var(--primaryColor2);
					}
				}
			}
		}

		.range-picker {
			height: fit-content;
			max-width: var(--rangePickerMaxWidth);
			min-height: var(--filterSameHeight);
			border-radius: var(--sp1x);
		}
	}

	.filter-second-line {
		display: flex;
		margin-top: var(--secondLineMarginTop);

		.reset-filter {
			display: inline-block;
			opacity: 0.5;
			cursor: pointer;
		}

		.hashtags-wrap {
			display: flex;

			.hashtag {
				margin-left: var(--hashtagMarginLeft);
				cursor: pointer;

				&.active {
					pointer-events: none;
				}
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--filterBarMarginTop: var(--sp5x);
		--filterPadding: var(--sp2x) var(--sp4x);
		--filterMarginRight: var(--sp2x);
		--filterMarginTop: var(--sp1-5x);
		--rangePickerMaxWidth: var(--sp47x);
		--filterSameHeight: var(--sp7x);
		--filterItemBorderRadius: var(--sp1-5x);
		--secondLineMarginTop: var(--sp4x);
		--hashtagMarginLeft: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--filterBarMarginTop: var(--sp4x);
		--filterPadding: var(--sp2x) var(--sp3x);
		--filterMarginRight: var(--sp1-5x);
		--filterMarginTop: var(--sp1-5x);
		--rangePickerMaxWidth: var(--sp37x);
		--filterSameHeight: var(--sp5x);
		--filterItemBorderRadius: var(--sp1-5x);
		--secondLineMarginTop: var(--sp4x);
		--hashtagMarginLeft: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--filterBarMarginTop: var(--sp4x);
		--filterPadding: var(--sp1-5x) var(--sp3x);
		--filterMarginRight: var(--sp1-5x);
		--filterMarginTop: var(--sp1-5x);
		--rangePickerMaxWidth: var(--sp33x);
		--filterSameHeight: var(--sp5x);
		--filterItemBorderRadius: var(--sp1-5x);
		--secondLineMarginTop: var(--sp4x);
		--hashtagMarginLeft: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--filterBarMarginTop: var(--sp4x);
		--filterPadding: var(--sp1-5x) var(--sp3x);
		--filterMarginRight: var(--sp1-5x);
		--filterMarginTop: var(--sp1-5x);
		--rangePickerMaxWidth: var(--sp31x);
		--filterSameHeight: var(--sp5x);
		--filterItemBorderRadius: var(--sp1-5x);
		--secondLineMarginTop: var(--sp4x);
		--hashtagMarginLeft: var(--sp2x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--rangePickerMaxWidth: var(--sp35x);
		--filterSameHeight: var(--sp5x);
		--filterItemBorderRadius: var(--sp1x);
		--secondLineMarginTop: var(--sp4x);
		--filterMarginTop: 0;
		--hashtagMarginLeft: var(--sp1x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--rangePickerMaxWidth: var(--sp39x);
		--filterSameHeight: var(--sp5x);
		--filterItemBorderRadius: var(--sp0-5x);
		--secondLineMarginTop: var(--sp3x);
		--filterMarginTop: 0;
		--hashtagMarginLeft: var(--sp1x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--rangePickerMaxWidth: 100%;
		--filterSameHeight: var(--sp5x);
		--filterItemBorderRadius: var(--sp1x);
		--secondLineMarginTop: var(--sp3x);
		--filterMarginTop: 0;
		--hashtagMarginLeft: var(--sp1x);

		.filter-first-line {
			flex-direction: column;
		}

		.range-picker {
			margin-top: var(--sp3x);
		}
	}
`

export default FilterBarStyle
